import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

// create a new instance for axios with baseURL taken from environment variables.
const instance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL // Use REACT_APP_API_URL environment variable as baseURL
});

const handleError = (error: AxiosError): Promise<AxiosError> => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.error('Error response:', error.response);
    console.error('Error status:', error.response.status);
    console.error('Error headers:', error.response.headers);
    console.error('Error data:', error.response.data);
  } else if (error.request) {
    // The request was made but no response was received
    console.error('The request was made but no response was received:', error.request);
  } else {
    // Something happened in setting up the request that triggered an error
    console.error('Something happened in setting up the request that triggered an error:', error.message);
  }
  console.error('Error config:', error.config);

  // Pass the error to the next interceptor or catch block
  return Promise.reject(error);
};

instance.interceptors.response.use(
  (response: AxiosResponse) => response, // Pass the response if successful
  handleError
);

export { instance };
